import { render, staticRenderFns } from "./WrsViLabel.vue?vue&type=template&id=28e405a4&"
import script from "./WrsViLabel.vue?vue&type=script&lang=js&"
export * from "./WrsViLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports